module.exports = __webpack_public_path__ + "static/ohtime-opengraph-4636888ba64fc82beee115c106f20eb1.png";